function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M448,320h-32c-2.816,0-5.488,0.576-8,1.472V312c0-13.232-10.768-24-24-24h-9.76l-7.992-32H352v-80h30.248l7.992-32H400 v-16h-64V96h-16v32h-64v16h9.76l7.992,32H304v80h-14.248l-4.264,17.08L276.944,256H168v-80h32c8.824,0,16-7.176,16-16v-16 c13.232,0,24-10.768,24-24V40c0-13.232-10.768-24-24-24H72c-13.232,0-24,10.768-24,24v80c0,13.232,10.768,24,24,24v16 c0,8.824,7.176,16,16,16h32v112h-8c-13.232,0-24,10.768-24,24v9.472c-2.512-0.896-5.184-1.472-8-1.472H48 c-13.232,0-24,10.768-24,24v128c0,13.232,10.768,24,24,24h32c13.232,0,24-10.768,24-24v-24h288v24c0,13.232,10.768,24,24,24h32 c13.232,0,24-10.768,24-24V344C472,330.768,461.232,320,448,320z M88,352H72v16h16v16H72v16h16v8v8H72v16h16v16H72v16h16v8 c0,4.416-3.584,8-8,8H48c-4.416,0-8-3.584-8-8v-8h16v-16H40v-16h16v-16H40v-16h16v-16H40v-16h16v-16H40v-8c0-4.416,3.584-8,8-8h32 c4.416,0,8,3.584,8,8V352z M286.248,160l-4-16h91.512l-4.008,16H286.248z M336,176v80h-16v-80H336z M302.256,272h51.496l4.008,16 h-59.512L302.256,272z M267.056,272l8,16H168v-16H267.056z M64,40c0-4.416,3.584-8,8-8h32v32H64V40z M80,112v16h-8 c-4.416,0-8-3.584-8-8V80h40c8.824,0,16-7.176,16-16V32h96c4.416,0,8,3.584,8,8v80c0,4.416-3.584,8-8,8h-88v-16h-16v16H96v-16H80z  M88,160v-16h112v16H88z M152,176v136c0,4.416-3.584,8-8,8s-8-3.584-8-8V176H152z M392,432H104v-16h288V432z M131.608,400 l12.192-32H168v32H131.608z M184,400v-32h16v32H184z M216,400v-32h40v32H216z M272,400v-32h16v32H272z M304,400v-32h16v32H304z  M336,400v-32h16.192l12.192,32H336z M392,344v56h-10.488l-18.288-48H132.776l-18.288,48H104v-56v-32c0-4.416,3.584-8,8-8h8v8 c0,13.232,10.768,24,24,24s24-10.768,24-24v-8h216c4.416,0,8,3.584,8,8V344z M456,352h-16v16h16v16h-16v16h16v16h-16v16h16v16h-16 v16h16v8c0,4.416-3.584,8-8,8h-32c-4.416,0-8-3.584-8-8v-8h16v-16h-16v-16h16v-16h-16v-8v-8h16v-16h-16v-16h16v-16h-16v-8 c0-4.416,3.584-8,8-8h32c4.416,0,8,3.584,8,8V352z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 280,
  y: 320,
  width: 16,
  height: 16
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 312,
  y: 320,
  width: 16,
  height: 16
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 344,
  y: 320,
  width: 16,
  height: 16
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M168,40c-22.056,0-40,17.944-40,40c0,22.056,17.944,40,40,40c22.056,0,40-17.944,40-40C208,57.944,190.056,40,168,40z  M168,104c-13.232,0-24-10.768-24-24s10.768-24,24-24s24,10.768,24,24S181.232,104,168,104z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 160,
  y: 72,
  width: 16,
  height: 16
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 320,
  y: 64,
  width: 16,
  height: 16
})));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M328,32c-12.832,0-24.88,4.992-33.936,14.064l11.312,11.312c12.08-12.096,33.168-12.096,45.248,0l11.312-11.312 C352.88,36.992,340.832,32,328,32z"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M328,0c-21.36,0-41.456,8.32-56.568,23.432l11.312,11.312C294.832,22.656,310.904,16,328,16s33.168,6.656,45.256,18.744 l11.312-11.312C369.456,8.32,349.36,0,328,0z"
})));

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var SvgMarsRover = function SvgMarsRover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarsRover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mars-rover.b14abcd3.svg";
export { ForwardRef as ReactComponent };